import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css';
import 'leaflet/dist/leaflet.css';

import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from "./components/AppProvider";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { Provider } from 'react-redux';
import Store from './components/FetchStore/Store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter>
    <Provider store={Store}>
      <AppProvider>
        {/* <React.Profiler id="App" onRender={(id, phase, actualDuration) => console.log(`Component ${id} rendered in ${actualDuration}ms during ${phase}`)}> */}
        <App />
        {/* </React.Profiler> */}
      </AppProvider>
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
